import { render, staticRenderFns } from "./SessionDetailPlayer.vue?vue&type=template&id=436c8f07&scoped=true&"
import script from "./SessionDetailPlayer.vue?vue&type=script&lang=js&"
export * from "./SessionDetailPlayer.vue?vue&type=script&lang=js&"
import style0 from "./SessionDetailPlayer.vue?vue&type=style&index=0&id=436c8f07&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c8f07",
  null
  
)

export default component.exports